<template>
  <div class="storeApply">
    <div class="">
      <div class="shanchuB" v-if="status == -1">
        <spen
          class="iconfont icon-caozuo-shanchuB"
          style="margin-right: 0.10rem; font-size: 0.36rem;"
        ></spen>
        当前商户未申请认证
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
      <div
        class="shanchuB"
        v-if="status == 0"
        style="background-color: #eaf6ff; color: #4aafe4;"
      >
        <spen
          class="iconfont icon-dengdai"
          style="margin-right: 0.10rem;font-size: 0.36rem;"
        ></spen>
        商户资料待审核
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
      <div
        class="shanchuB"
        v-if="status == 8"
        style="background-color: #eaf6ff; color: #4aafe4;"
        @click="goSignUrl"
      >
        <spen
          class="iconfont icon-dengdai"
          style="margin-right: 0.10rem;font-size: 0.36rem;"
        ></spen>
        待签约，请点此完成商户协议签约
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
      <div
        class="shanchuB"
        v-if="status == 1"
        style="background-color: #fff4eb; color: #ff882e;"
      >
        <spen
          class="iconfont icon-dengdai"
          style="margin-right: 0.10rem;font-size: 0.36rem;"
        ></spen>
        商户资料正在审核中
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
      <div
        class="shanchuB"
        v-if="status == 5"
        style="background-color: #fff4eb; color: #ff882e;"
      >
        <spen
          class="iconfont icon-dengdai"
          style="margin-right: 0.10rem;font-size: 0.36rem;"
        ></spen>
        商户资料变更审核中
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
      <div
        class="jinggao"
        v-if="status == 2"
        style="background-color: #ffedf0; color: #fc575e;"
      >
        <div class="">
          <spen
            class="iconfont icon-jinggao"
            style="margin-right: 0.10rem;font-size: 0.36rem;"
          ></spen>
          <spen>当前商户认证已被驳回</spen>
          <div
            class="shanchuB2"
            v-if="subMercList.length > 0"
            @click="baseline = true"
          >
            报备详情
          </div>
        </div>
        <div class="" style="margin: 0.10rem 0 0 0.46rem">
          {{ statusmsg }}
        </div>
      </div>
      <div
        class="shanchuB"
        v-if="status == 3"
        style="background-color: #f5f5f5; color: #3eb7a1;"
      >
        <spen
          class="iconfont icon-tongguo"
          style="margin-right: 0.10rem;font-size: 0.36rem;"
        ></spen>
        当前商户已通过认证
        <div
          class="shanchuB2"
          v-if="subMercList.length > 0"
          @click="baseline = true"
        >
          报备详情
        </div>
      </div>
    </div>
    <div class="top">
      <div class="top_type" :class="type == 0 ? 'om' : ''" @click="type = 0">
        基本信息
      </div>
      <div
        class="top_type"
        :class="type == 1 ? 'om' : ''"
        @click="type = 1"
        v-if="type2 > 1"
      >
        {{ type2 == 2 ? "个体" : "企业" }}信息
      </div>
      <div
        class="top_type"
        :class="type == 2 ? 'om' : ''"
        @click="type = 2"
        v-if="type2 > 1"
      >
        法人信息
      </div>
      <div class="top_type" :class="type == 3 ? 'om' : ''" @click="type = 3">
        结算人信息
      </div>
      <div class="top_type" :class="type == 4 ? 'om' : ''" @click="type = 4">
        银行卡
      </div>
    </div>
    <!-- 基本信息 -->
    <div class="list" v-show="type == 0">
      <div class="item flex ali_center" @click="show_add4 = true">
        <div class="left">商户类型</div>
        <input
          type="text"
          :disabled="show_add4"
          v-model="choose_name3"
          placeholder="请选择商户类型"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">商户简称</div>
        <input
          type="text"
          v-model="shopname"
          placeholder="请填写商户简称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">商户全称</div>
        <input
          type="text"
          v-model="mercName"
          placeholder="请填写商户全称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">商户联系人</div>
        <input
          type="text"
          v-model="contactName"
          placeholder="请填写商户联系人"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">联系人电话</div>
        <input
          type="number"
          v-model="phone"
          placeholder="请填写联系人电话"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item2 flex ali_center" @click="showAddress = true">
        <div class="left">商户地址</div>
        <div class="right flex ali_center flex_between">
          <spen class="a">{{ addressText }}</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left">详细地址</div>
        <input
          type="text"
          v-model="detail"
          placeholder="请填写商户详细地址"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="logo">
        <div class="left on">上传门头照</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="logo" v-if="logo" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div class="logo">
        <div class="left on">上传收银台照</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded2"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="license" v-if="license" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div class="logo">
        <div class="left on">上传门店内景照</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded3"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="shop_bg" v-if="shop_bg" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
    </div>
    <!-- 个体户、企业商户必传 -->
    <div class="list" v-show="type == 1">
      <div class="item flex ali_center" @click="date_show1 = true">
        <div class="left">开始时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ certStartTime || "请选择营业执照开始时间" }}
        </div>
      </div>
      <div class="item flex ali_center" @click="onclick2">
        <div class="left">是否长期</div>
        <input
          type="text"
          v-model="choose_name2"
          :disabled="show_add2"
          placeholder="请选择是否长期"
          placeholder-style="color: #333;font-size:0.0.30rem"
        />
      </div>
      <div
        class="item flex ali_center"
        v-if="choose_name2 == '否'"
        @click="date_show2 = true"
      >
        <div class="left">截止时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ bussAuthEndTime || "请选择营业执照截止时间" }}
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left">信用代码</div>
        <input
          type="text"
          v-model="mercBusLicense.bussAuthNum"
          placeholder="请填写统一社会信用代码"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">执照名称</div>
        <input
          type="text"
          v-model="mercBusLicense.bussAuthName"
          placeholder="请填写营业执照名称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>

      <div class="item flex ali_center">
        <div class="left">执照地址</div>
        <input
          type="text"
          v-model="mercBusLicense.bussAuthAddress"
          placeholder="请填写营业执照地址"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="logo">
        <div class="left on">上传营业执照图片</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded4"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgUrl" v-if="imgUrl" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
    </div>
    <!-- 法人信息，个体，企业必传 -->
    <div class="list" v-show="type == 2">
      <div class="item flex ali_center" @click="date_show3 = true">
        <div class="left">开始时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ certStartTime2 || "请选择法人证件开始时间" }}
        </div>
      </div>
      <div class="item flex ali_center" @click="onclick3">
        <div class="left">是否长期</div>
        <input
          type="text"
          v-model="choose_name5"
          :disabled="show_add5"
          placeholder="请选择是否长期"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div>
      <div
        class="item flex ali_center"
        v-if="choose_name5 == '否'"
        @click="date_show4 = true"
      >
        <div class="left">截止时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ bussAuthEndTime2 || "请选择法人证件截止时间" }}
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left">法人证件号</div>
        <input
          type="text"
          v-model="idCard.certNo"
          placeholder="请填写法人证件号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">法人名称</div>
        <input
          type="text"
          v-model="idCard.certName"
          placeholder="请填写法人证件名称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="logo">
        <div class="left on">上传法人证件国徽面图片</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded5"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgNegative" v-if="imgNegative" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div class="logo">
        <div class="left on">上传法人证件人头面图片</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded6"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgPositive" v-if="imgPositive" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
    </div>
    <!-- 结算人信息 -->
    <div class="list" v-show="type == 3">
      <div class="item flex ali_center" @click="date_show5 = true">
        <div class="left">开始时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ certStartTime3 || "请选择结算人证件开始时间" }}
        </div>
      </div>
      <div class="item flex ali_center" @click="onclick4">
        <div class="left">是否长期</div>
        <input
          type="text"
          v-model="choose_name6"
          :disabled="show_add6"
          placeholder="请选择是否长期"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div>
      <div
        class="item flex ali_center"
        v-if="choose_name6 == '否'"
        @click="date_show6 = true"
      >
        <div class="left">截止时间</div>
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ bussAuthEndTime3 || "请选择结算人证件截止时间" }}
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left" style="width: 2.80rem;">结算人证件号</div>
        <input
          type="text"
          v-model="accountIdCard.certNo"
          placeholder="请填写结算人证件号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">结算人名称</div>
        <input
          type="text"
          v-model="accountIdCard.certName"
          placeholder="请填写结算人证件名称"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="logo">
        <div class="left on">上传结算人证件国徽面图片</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded7"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgNegative2" v-if="imgNegative2" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div class="logo">
        <div class="left on">上传结算人证件人头面图片</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded8"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgPositive2" v-if="imgPositive2" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
    </div>
    <!-- 银行卡 -->
    <div class="list" v-show="type == 4">
      <div class="item flex ali_center" @click="onclick">
        <div class="left">卡片类型</div>
        <input
          type="text"
          :disabled="show_add"
          v-model="choose_name"
          placeholder="请选择卡片类型"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">银行卡号</div>
        <input
          type="text"
          v-model="bankCard.bankCardNo"
          placeholder="请填写银行卡号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">持卡人姓名</div>
        <input
          type="text"
          v-model="bankCard.bankHolder"
          placeholder="请填写持卡人姓名"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">预留手机号</div>
        <input
          type="number"
          v-model="bankCard.phone"
          placeholder="请填写预留手机号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item2 flex ali_center" @click="add_list">
        <div class="left">支行地址</div>
        <div class="right flex ali_center flex_between">
          <spen class="a">{{ addressText3 }}</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
      </div>
      <div class="item flex ali_center" style="position: relative;">
        <div class="left">支行名称</div>
        <input
          type="text"
          v-model="branch"
          placeholder="输入搜索支行名称(必须选择)"
          placeholder-style="color: #ccc;font-size:0.30rem"
          @input="getcontactLine"
        />
        <div class="branch_list" v-if="!start && contact_line.length > 0">
          <div
            v-for="(item, index) in contact_line"
            :key="index"
            class="contact_li"
            @click="subBranch(item)"
          >
            {{ item.branch_name }}
          </div>
        </div>
      </div>
      <div class="logo" v-show="choose_name == '对私账户'">
        <div class="left on">上传对私银行卡卡面图片(对私必传)</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded9"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="imgUrl2" v-if="imgUrl2" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div class="logo" v-show="choose_name == '对公账户'">
        <div class="left on">上传对公账户开户许可证图片(对公必传)</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded10"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="licenseUrl" v-if="licenseUrl" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
      </div>
      <div
        class="logo"
        style="position: relative;padding-bottom: 10px;"
        v-show="choose_name == '对私账户' && type2 > 1"
      >
        <div class="left on">上传对私非法人结算授权函图片(对私非法人必传)</div>
        <VueCoreImageUpload
          class="btn btn-primary pic"
          :crop="false"
          compress="80"
          @errorhandle="errorhandle"
          @imageuploaded="imageuploaded11"
          :headers="headers"
          :max-file-size="10485760"
          :credentials="false"
          inputAccept="image/*"
          inputOfFile="file"
          :url="url"
          ref="upImg"
        >
          <div class="pic">
            <img :src="grantAuthUrl" v-if="grantAuthUrl" />
            <img src="../../assets/images/add_logo.png" v-else class="alter" />
          </div>
        </VueCoreImageUpload>
        <div class="scbbc" @click="submit(0, 1)">删除并保存</div>
      </div>
    </div>
    <div class="submit" @click="submit(0)">保存当前信息</div>
    <div class="submit" @click="submit(1)">保存并提交</div>
    <!-- <div class="examine" @click="$goNext('/pages/store/record')">
      查看审核记录
    </div> -->

    <div v-if="showAddress">
      <CitySelect
        ref="cityselect"
        v-model="showAddress"
        :callback="result"
        :items="addressList"
        :ready="ready"
        provance=""
        city=""
        area=""
      ></CitySelect>
    </div>
    <div v-if="showAddress2">
      <CitySelect
        ref="cityselect"
        v-model="showAddress2"
        :callback="result2"
        :items="addressList2"
        :ready="ready"
        provance=""
        city="false"
        area="false"
      ></CitySelect>
    </div>
    <div v-if="showAddress3">
      <CitySelect
        ref="cityselect"
        v-model="showAddress3"
        :callback="result3"
        :items="addressList3"
        :ready="ready"
        provance=""
        city=""
        area="false"
      ></CitySelect>
    </div>
    <gender
      :show_add="show_add"
      :gender="choose_name"
      @show_gender="show_add = false"
      @carefuls="carefuls"
    ></gender>
    <gender2
      :show_add="show_add2"
      :gender="choose_name2"
      @show_gender="show_add2 = false"
      @carefuls="carefuls2"
    >
    </gender2>
    <gender5
      :show_add="show_add5"
      :gender="choose_name5"
      @show_gender="show_add3 = false"
      @carefuls="carefuls5"
    >
    </gender5>
    <gender6
      :show_add="show_add6"
      :gender="choose_name6"
      @show_gender="show_add6 = false"
      @carefuls="carefuls6"
    >
    </gender6>
    <gender3
      :show_add="show_add4"
      :gender="choose_name3"
      @show_gender="show_add4 = false"
      @carefuls="carefuls3"
    >
    </gender3>
    <!-- <setMeal
      @showCombo="showCombo"
      :show_add3="show_add3"
      @Combo="Combo"
      v-if="show_add3"
      :combo3="combo"
      :stick="stick"
    ></setMeal> -->
    <div class="mask" v-if="baseline" @click="baseline = false"></div>
    <div class="report" v-if="baseline">
      <div class="report_top">
        报备详情
        <spen
          class="iconfont icon-baseline-close-px"
          @click="baseline = false"
        ></spen>
      </div>
      <div
        v-for="(item, index) in subMercList"
        :key="index"
        class="subMercList"
      >
        <spen
          class="iconfont icon-tongguo"
          style="margin-right: 0.10rem;font-size: 0.36rem;color: #3eb7a1;"
          v-if="item.status == '00'"
        ></spen>
        <spen
          class="iconfont icon-jinggao"
          style="margin-right: 0.10rem;font-size: 0.36rem;color: #fc575e;"
          v-if="item.status == '01'"
        ></spen>
        <spen style="margin-right: 0.10rem;" v-if="item.subMchType == 'ZFB'"
          >支付宝支付：</spen
        >
        <spen style="margin-right: 0.10rem;" v-if="item.subMchType == 'WX'"
          >微信支付：</spen
        >
        {{ item.remark }}
        <button
          class="attention"
          v-if="
            item.subMchType == 'ZFB' &&
              item.status == '00' &&
              item.subMchId.indexOf('CUPS') > -1
          "
          @click="
            $goNext(
              '/pages/store/attestation?type=2&id=' +
                item.subMchId +
                '&mercName=' +
                mercName +
                '&contactName=' +
                contactName
            )
          "
        >
          去认证
        </button>
        <button
          class="attention"
          v-if="
            item.subMchType == 'WX' &&
              item.status == '00' &&
              item.subMchId.indexOf('CUPS') > -1
          "
          @click="
            $goNext(
              '/pages/store/attestation?type=1&id=' +
                item.subMchId +
                '&mercName=' +
                mercName +
                '&contactName=' +
                contactName
            )
          "
        >
          去认证
        </button>
      </div>
    </div>
    <div class="mask" v-if="date_show1" @click="date_show1 = false"></div>
    <div v-if="date_show1" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange1"
        @cancel="date_show1 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show2" @click="date_show2 = false"></div>
    <div v-if="date_show2" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange2"
        @cancel="date_show2 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show3" @click="date_show3 = false"></div>
    <div v-if="date_show3" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange3"
        @cancel="date_show3 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show4" @click="date_show4 = false"></div>
    <div v-if="date_show4" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange4"
        @cancel="date_show4 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show5" @click="date_show5 = false"></div>
    <div v-if="date_show5" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange5"
        @cancel="date_show5 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show6" @click="date_show6 = false"></div>
    <div v-if="date_show6" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange6"
        @cancel="date_show6 = false"
      >
      </DatetimePicker>
    </div>
  </div>
</template>

<script>
import gender from "@components/public/gender2.vue";
import gender2 from "@components/public/gender3.vue";
import gender3 from "@components/public/gender4.vue";
import gender5 from "@components/public/gender5.vue";
import gender6 from "@components/public/gender6.vue";

import {
  getinitialMercInfoTdz,
  initialMercInfoTdz,
  MercInfoimg,
  getcontactLine
} from "../../api/store";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getCity_new, gettreea } from "@api/public";
// import setMeal from "@components/public/setMeal.vue";
import VueCoreImageUpload from "vue-core-image-upload";
import { VUE_APP_API_URL } from "@utils";
import { DatetimePicker } from "vant";

export default {
  name: "storeApply4",
  components: {
    CitySelect,
    // setMeal,
    gender,
    gender2,
    gender3,
    gender5,
    gender6,
    DatetimePicker,
    VueCoreImageUpload
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      baseline: false,
      choose_name: "",
      choose_name2: "",
      choose_name5: "",
      choose_name6: "",
      choose_name3: "请选择商户类型",
      type: 0,
      type2: 1,
      status: -1,
      statusmsg: "",
      signUrl: "",
      checked: false,
      showAddress: false,
      showAddress3: false,
      valueArr: [0, 0, 0],
      valueArr3: [0, 0],
      id: 0,
      uid: "",
      ready: false,
      addressText: "请选择商户地址",
      addressText3: "请选择支行地址",
      area: "请选择门店所在街道",
      addressList: [],
      shopname: "",
      contactName: "",
      mercName: "",
      realname: "",
      phone: "",
      address: "",
      detail: "",
      desc: "",
      logo: "",
      logo_img: "",
      imgUrl: "",
      imgUrl2: "",
      imgNegative: "",
      imgNegative2: "",
      imgPositive: "",
      imgPositive2: "",
      imgUrl_img: "",
      imgUrl2_img: "",
      imgNegative_img: "",
      imgNegative2_img: "",
      imgPositive_img: "",
      imgPositive2_img: "",
      shop_bg: "",
      license: "",
      shop_bg_img: "",
      license_img: "",
      grantAuthUrl: "",
      licenseUrl: "",
      grantAuthUrl_img: "",
      licenseUrl_img: "",
      card_from: "",
      card_back: "",
      latitude: 0,
      longitude: 0,
      latitude2: 0,
      longitude2: 0,
      contactLine: "",
      province: "",
      city: "",
      province3: "",
      city3: "",
      district: "",
      province_code: "",
      city_code: "",
      district_code: "",
      province2: "",
      city2: "",
      district2: "",
      contact_line: [],
      show_add3: false,
      combo: 0,
      branch: "",
      stick: "请选择让利比例",
      address_jw: "",
      showAddress2: false,
      addressList2: [],
      addressList3: [],
      valueArr2: [0],
      showStreet: false,
      show_add: false,
      show_add2: false,
      // show_add3: false,
      show_add5: false,
      show_add6: false,
      show_add4: false,
      bussAuthEndTime: "",
      certStartTime: "",
      bussAuthEndTime2: "",
      certStartTime2: "",
      bussAuthEndTime3: "",
      date_show3: false,
      date_show1: false,
      date_show2: false,
      date_show5: false,
      date_show4: false,
      date_show6: false,
      certStartTime3: "",
      DatecertStartTime3: new Date(),
      startDate: new Date(1900, 1, 1),
      endDate: new Date(2100, 1, 1),
      start: false,
      open: false,
      subMercList: [],
      mercCode: "", //商户编号，修改商户信息时候必传
      mercBusLicense: {
        bussAuthEndTime: "", //营业执照截止时间，短期必传
        bussAuthNum: "", //统一社会信用代码
        bussAuthName: "", //营业执照名称
        bussAuthAddress: "", //营业执照地址
        bussAuthStartTime: "", //营业执照开始时间
        buslicType: "", //是否长期。0：否；1：是
        imgUrl: "" //营业执照图片链接编码
      }, //个体户、企业商户必传
      idCard: {
        imgNegative: "", //法人证件国徽面链接编码
        certStartTime: "", //法人证件开始时间
        certEndTime: "", //法人证件有效截止时间，长期填长期
        certNo: "", //法人证件号
        certName: "", //法人证件名称
        imgPositive: "" //法人证件人头面链接编码
      }, //法人信息，个体，企业必传
      accountIdCard: {
        imgNegative: "", //结算人证件国徽面
        certStartTime: "", //结算人证件开始时间
        certEndTime: "", //结算人证件截止时间
        certNo: "", //结算人证件号
        certName: "", //结算人姓名
        imgPositive: "" //结算人证件人头面
      }, //结算人信息
      bankCard: {
        bankHolder: "", //持卡人姓名
        bankCardNo: "", //银行卡号
        accountType: "", //卡片类型。01：对私账户（自然人只对私、个体工商户可选）; 02：对公账户;
        contactLine: "", //支行联行号
        phone: "", //预留手机号
        imgUrl: "", //对私银行卡卡面，对私账户必传
        licenseUrl: "", //对公账户开户许可证，对公账户必传
        grantAuthUrl: "" //对私非法人结算授权函，对私非法人结算必传
      } //银行卡
    };
  },

  mounted() {
    this.getinitialMercInfo2();
    this.getCity();
    this.getCity2();
  },
  methods: {
    goSignUrl() {
      window.location.href = this.signUrl;
    },
    add_list() {
      this.showAddress3 = true;
      this.contact_line = [];
    },
    subBranch(item) {
      this.branch = item.branch_name;
      this.bankCard.contactLine = item.branch_no;
      this.start = true;
    },
    getcontactLine() {
      let that = this;
      if (!this.city3) {
        this.branch = "";
        return this.$dialog.error("请先选择支行地址");
      }
      if (!this.branch.trim() || !this.branch) {
        return;
      }
      console.log(this.start);
      if (this.start) {
        this.start = false;
      } else {
        let data = {
          city_name: this.city3,
          province_name: this.province3,
          branch_name: this.branch
        };
        getcontactLine(data).then(res => {
          that.contact_line = res.data;
        });
      }
    },
    getinitialMercInfo2() {
      let that = this;
      getinitialMercInfoTdz()
        .then(res => {
          //商户编号，修改商户信息时候必传
          that.mercCode = res.data.mercCode || "";
          if (res.data.status !== 0) {
            that.status = res.data.status || -1;
          } else {
            that.status = res.data.status || 0;
          }
          that.statusmsg = res.data.statusmsg || "";
          that.signUrl = res.data.signUrl || "";
          that.subMercList = res.data.subMercList || [];
          //基本信息
          if (res.data.mercBaseInfo) {
            that.shopname = res.data.mercBaseInfo.alias || "";
            that.mercName = res.data.mercBaseInfo.mercName || "";
            that.contactName = res.data.mercBaseInfo.contactName || "";
            that.phone = res.data.mercBaseInfo.contactMobile || "";
            that.type2 = res.data.mercBaseInfo.mercType || "";
            that.choose_name3 = res.data.mercBaseInfo.mercTypeName || "";
            if (res.data.mercBaseInfo.province) {
              that.addressText =
                res.data.mercBaseInfo.province2 +
                  " " +
                  res.data.mercBaseInfo.city2 +
                  " " +
                  res.data.mercBaseInfo.district2 || "";
              that.province_code = res.data.mercBaseInfo.province || "";
              that.city_code = res.data.mercBaseInfo.city || "";
              that.district_code = res.data.mercBaseInfo.district || "";
              that.province2 = res.data.mercBaseInfo.province2 || "";
              that.city2 = res.data.mercBaseInfo.city2 || "";
              that.district2 = res.data.mercBaseInfo.district2 || "";
            }

            that.detail = res.data.mercBaseInfo.address || "";
            that.logo = res.data.mercBaseInfo.frontPic_img || "";
            that.logo_img = res.data.mercBaseInfo.frontPic || "";
            that.shop_bg = res.data.mercBaseInfo.interior_img || "";
            that.shop_bg_img = res.data.mercBaseInfo.interior || "";
            that.license = res.data.mercBaseInfo.cashDesk_img || "";
            that.license_img = res.data.mercBaseInfo.cashDesk || "";
          }

          //个体户、企业商户必传
          if (res.data.mercBusLicense) {
            that.mercBusLicense.bussAuthNum =
              res.data.mercBusLicense.bussAuthNum || "";
            that.mercBusLicense.bussAuthName =
              res.data.mercBusLicense.bussAuthName || "";
            that.mercBusLicense.bussAuthAddress =
              res.data.mercBusLicense.bussAuthAddress || "";
            that.certStartTime =
              res.data.mercBusLicense.bussAuthStartTime || "";
            if (
              res.data.mercBusLicense.buslicType == "0" ||
              res.data.mercBusLicense.buslicType == "1"
            ) {
              that.choose_name2 =
                res.data.mercBusLicense.buslicType == "0" ? "否" : "是" || "";
              if (that.choose_name2 == "是") {
                that.bussAuthEndTime = "" || "";
              } else {
                that.bussAuthEndTime =
                  res.data.mercBusLicense.bussAuthEndTime || "";
              }
            }
            that.imgUrl = res.data.mercBusLicense.imgUrl_img || "";
            that.imgUrl_img = res.data.mercBusLicense.imgUrl || "";
          }

          //法人信息，个体，企业必传
          if (res.data.idCard) {
            that.certStartTime2 = res.data.idCard.certStartTime || "";
            that.idCard.certName = res.data.idCard.certName || "";
            that.idCard.certNo = res.data.idCard.certNo || "";
            that.imgPositive = res.data.idCard.imgPositive_img || "";
            that.imgPositive_img = res.data.idCard.imgPositive || "";
            that.imgNegative = res.data.idCard.imgNegative_img || "";
            that.imgNegative_img = res.data.idCard.imgNegative || "";
            that.choose_name5 = res.data.idCard.choose_name5 || "";
            if (that.choose_name5 == "是") {
              that.bussAuthEndTime2 = "" || "";
            } else {
              that.bussAuthEndTime2 = res.data.idCard.certEndTime || "";
            }
          }

          //结算人信息
          if (res.data.accountIdCard) {
            that.accountIdCard.certName = res.data.accountIdCard.certName || "";
            that.accountIdCard.certNo = res.data.accountIdCard.certNo || "";
            that.certStartTime3 = res.data.accountIdCard.certStartTime || "";
            that.imgNegative2 = res.data.accountIdCard.imgNegative_img || "";
            that.imgNegative2_img = res.data.accountIdCard.imgNegative || "";
            that.imgPositive2 = res.data.accountIdCard.imgPositive_img || "";
            that.imgPositive2_img = res.data.accountIdCard.imgPositive || "";
            that.choose_name6 = res.data.accountIdCard.choose_name6 || "";
            if (that.choose_name6 == "是") {
              that.bussAuthEndTime3 = "" || "";
            } else {
              that.bussAuthEndTime3 = res.data.accountIdCard.certEndTime || "";
            }
          }

          //银行卡
          if (res.data.bankCard) {
            that.bankCard.bankHolder = res.data.bankCard.bankHolder || "";
            that.bankCard.bankCardNo = res.data.bankCard.bankCardNo || "";
            if (res.data.bankCard.accountType) {
              that.choose_name =
                res.data.bankCard.accountType == "01"
                  ? "对私账户"
                  : res.data.bankCard.accountType == "02"
                  ? "对公账户"
                  : "" || "";
            }
            that.bankCard.contactLine = res.data.bankCard.contactLine || "";
            that.bankCard.phone = res.data.bankCard.phone || "";
            that.imgUrl2 = res.data.bankCard.imgUrl_img || "";
            that.imgUrl2_img = res.data.bankCard.imgUrl || "";
            that.grantAuthUrl = res.data.bankCard.grantAuthUrl_img || "";
            that.grantAuthUrl_img = res.data.bankCard.grantAuthUrl || "";
            that.licenseUrl = res.data.bankCard.licenseUrl_img || "";
            that.licenseUrl_img = res.data.bankCard.licenseUrl || "";
            that.branch = res.data.bankCard.branch_name || "";
            if (res.data.bankCard.province_name) {
              that.addressText3 =
                res.data.bankCard.province_name +
                  " " +
                  res.data.bankCard.city_name || "";
              that.province3 = res.data.bankCard.province_name || "";
              that.city3 = res.data.bankCard.city_name || "";
            }
          }
        })
        .catch(res => {
          console.log(res);
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    bindDateChange1: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.certStartTime = year + "-" + month + "-" + date;
      this.date_show1 = false;
    },
    bindDateChange2: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime = year + "-" + month + "-" + date;
      this.date_show2 = false;
    },
    bindDateChange3: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.certStartTime2 = year + "-" + month + "-" + date;
      this.date_show3 = false;
    },
    bindDateChange4: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime2 = year + "-" + month + "-" + date;
      this.date_show4 = false;
    },
    bindDateChange5: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.certStartTime3 = year + "-" + month + "-" + date;
      this.date_show5 = false;
    },
    bindDateChange6: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime3 = year + "-" + month + "-" + date;
      this.date_show6 = false;
    },
    carefuls(res) {
      this.choose_name =
        res == "01" ? "对私账户" : res == "02" ? "对公账户" : "";
      this.show_add = false;
    },
    carefuls2(res) {
      this.choose_name2 = res == "0" ? "否" : res == "1" ? "是" : "";
      this.show_add2 = false;
    },
    carefuls5(res) {
      this.choose_name5 = res == "0" ? "否" : res == "1" ? "是" : "";
      this.show_add5 = false;
    },
    carefuls6(res) {
      this.choose_name6 = res == "0" ? "否" : res == "1" ? "是" : "";
      this.show_add6 = false;
    },
    carefuls3(res) {
      this.choose_name3 =
        res == "1"
          ? "小微商户"
          : res == "2"
          ? "个体工商户"
          : res == "3"
          ? "企业商户"
          : "请选择商户类型";
      this.show_add4 = false;
      this.type2 = res;
    },
    onclick4() {
      this.show_add6 = true;
    },
    onclick3() {
      this.show_add5 = true;
    },
    onclick2() {
      this.show_add2 = true;
    },

    onclick() {
      this.show_add = true;
    },
    checkeds() {
      this.checked = !this.checked;
    },
    Combo(type) {
      this.combo = type.num;
      this.stick = type.name;
      this.show_add3 = false;
    },
    showCombo() {
      this.show_add3 = false;
    },

    gettreea(city, area) {
      gettreea({
        city,
        area
      }).then(res => {
        this.addressList2 = res.data;
        if (res.data.length > 0) {
          this.showStreet = true;
        }
      });
    },

    result(ret) {
      console.log(ret);
      this.province2 = ret.itemName1;
      this.city2 = ret.itemName2;
      this.district2 = ret.itemName3;
      this.province_code = ret.itemValue1;
      this.city_code = ret.itemValue2;
      this.district_code = ret.itemValue3;
      this.addressText =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.cityId = ret.itemValue2;
      this.address = {
        province: this.province2,
        city: this.city2,
        district: this.district2,
        city_id: this.cityId
      };
      // this.gettreea(ret.itemName2, ret.itemName3);
    },
    result2(ret) {
      this.area = ret.itemName1;
    },
    result3(ret) {
      let province = ret.itemName1;
      let city = ret.itemName2;
      this.province3 = province;
      this.city3 = city;
      this.addressText3 = province + " " + city;
    },
    getCity() {
      getCity_new()
        .then(res => {
          // this.recity(res.data);
          this.addressList = res.data;
          this.ready = true;
        })
        .catch(res => {
          console.log(res);
        });
    },
    getCity2() {
      getCity_new()
        .then(res => {
          let addressList3 = res.data;
          for (let i = 0; i < addressList3.length; i++) {
            for (let j = 0; j < addressList3[i].c.length; j++) {
              addressList3[i].c[j].c = "";
            }
          }
          this.addressList3 = addressList3;
        })
        .catch(res => {
          console.log(res);
        });
    },
    recity(arr) {
      let province = [],
        city = [],
        area = [];
      if (arr.length) {
        let citychildren = arr[0].c || [];
        let areachildren = citychildren.length ? citychildren[0].c || [] : [];
        arr.forEach(item => {
          province.push(item);
        });
        citychildren.forEach(item => {
          city.push(item);
        });
        areachildren.forEach(item => {
          area.push(item);
        });
        this.province = province;
        this.city = city;
        this.district = area;
      }
    },
    submit(num, type2) {
      if (this.open) return that.$dialog.error("图片上传中");
      let that = this;
      let data = {
        type: num,
        mercCode: this.mercCode, //商户编号，修改商户信息时候必传
        mercBaseInfo: {
          frontPic: this.logo_img, //门头照
          frontPic_img: this.logo, //门头照
          interior: this.shop_bg_img, //内景照
          interior_img: this.shop_bg, //内景照
          address: this.detail, //地址
          contactName: this.contactName, //联系人
          cashDesk: this.license_img, //收银台照
          cashDesk_img: this.license, //收银台照
          alias: this.shopname, //商户别名
          mcc: "8999", //mcc编码
          city: this.city_code, //城市
          district: this.district_code, //地区
          province: this.province_code, //省
          city2: this.city2, //城市
          district2: this.district2, //地区
          province2: this.province2, //省
          mccName: this.realname, //经营类目
          mercName: this.mercName, //商户全称
          mercType: this.type2, //商户类型，1、小微商户；2、个体户商户；3、企业商户
          mercTypeName: this.choose_name3, //商户类型名称
          contactMobile: this.phone //联系人手机号
        }, //商户基本信息
        mercBusLicense: {
          bussAuthEndTime:
            this.choose_name2 == "否"
              ? this.bussAuthEndTime
              : this.choose_name2 == "是"
              ? "长期"
              : "", //营业执照截止时间，短期必传
          bussAuthNum: this.mercBusLicense.bussAuthNum, //统一社会信用代码
          bussAuthName: this.mercBusLicense.bussAuthName, //营业执照名称
          bussAuthAddress: this.mercBusLicense.bussAuthAddress, //营业执照地址
          bussAuthStartTime: this.certStartTime, //营业执照开始时间
          buslicType:
            this.choose_name2 == "否"
              ? "0"
              : this.choose_name2 == "是"
              ? "1"
              : "", //是否长期。0：否；1：是
          imgUrl: this.imgUrl_img, //营业执照图片链接编码
          imgUrl_img: this.imgUrl //营业执照图片链接编码
        }, //个体户、企业商户必传
        idCard: {
          imgNegative: this.imgNegative_img, //法人证件国徽面链接编码
          imgNegative_img: this.imgNegative, //法人证件国徽面链接编码
          certStartTime: this.certStartTime2, //法人证件开始时间
          choose_name5: this.choose_name5,
          certEndTime:
            this.choose_name5 == "否"
              ? this.bussAuthEndTime2
              : this.choose_name5 == "是"
              ? "长期"
              : "", //法人证件有效截止时间，长期填长期
          certNo: this.idCard.certNo, //法人证件号
          certName: this.idCard.certName, //法人证件名称
          imgPositive: this.imgPositive_img, //法人证件人头面链接编码
          imgPositive_img: this.imgPositive //法人证件人头面链接编码
        }, //法人信息，个体，企业必传
        accountIdCard: {
          imgNegative: this.imgNegative2_img, //结算人证件国徽面
          imgNegative_img: this.imgNegative2, //结算人证件国徽面
          certStartTime: this.certStartTime3, //结算人证件开始时间
          choose_name6: this.choose_name6,
          certEndTime:
            this.choose_name6 == "否"
              ? this.bussAuthEndTime3
              : this.choose_name6 == "是"
              ? "长期"
              : "", //结算人证件截止时间
          certNo: this.accountIdCard.certNo, //结算人证件号
          certName: this.accountIdCard.certName, //结算人姓名
          imgPositive: this.imgPositive2_img, //结算人证件人头面
          imgPositive_img: this.imgPositive2 //结算人证件人头面
        }, //结算人信息
        bankCard: {
          bankHolder: this.bankCard.bankHolder, //持卡人姓名
          bankCardNo: this.bankCard.bankCardNo, //银行卡号
          accountType:
            this.choose_name == "对私账户"
              ? "01"
              : this.choose_name == "对公账户"
              ? "02"
              : "", //卡片类型。01：对私账户（自然人只对私、个体工商户可选）; 02：对公账户;
          contactLine: this.bankCard.contactLine, //支行联行号
          branch_name: this.branch, //支行联行名称
          city_name: this.city3, //支行联行市
          province_name: this.province3, //支行联行省
          phone: this.bankCard.phone, //预留手机号
          imgUrl: this.imgUrl2_img, //对私银行卡卡面，对私账户必传
          imgUrl_img: this.imgUrl2, //对私银行卡卡面，对私账户必传
          licenseUrl: this.licenseUrl_img, //对公账户开户许可证，对公账户必传
          licenseUrl_img: this.licenseUrl, //对公账户开户许可证，对公账户必传
          grantAuthUrl: type2 == 1 ? "" : this.grantAuthUrl_img, //对私非法人结算授权函，对私非法人结算必传
          grantAuthUrl_img: type2 == 1 ? "" : this.grantAuthUrl //对私非法人结算授权函，对私非法人结算必传
        } //银行卡
      };
      initialMercInfoTdz(data)
        .then(res => {
          if (res.data && res.data.mercCode) {
            that.mercCode = res.data.mercCode;
          }
          that.getinitialMercInfo2();
          if (num == 1 && that.mercCode) {
            setTimeout(() => {
              that.submit(0);
            }, 1500);
          }
          that.$dialog.success(res.msg);
          // that.$tips({
          //   title: res.msg
          // }, {
          //   tab: 1
          // });
        })
        .catch(res => {
          console.log(res);
          that.$dialog.error(res.msg);
        });
    },
    errorhandle() {
      this.$dialog.error("上传图片超出10M");
    },
    imageuploaded(res) {
      if (res.status !== 200) {
        if (res.status !== 200) {
          if (res.msg == "Upload file does not exist") {
            return this.$dialog.error("上传图片超出10M");
          } else {
            return this.$dialog.error(res.msg || "上传图片失败");
          }
        }
      }

      this.logo = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "logo");
    },
    imageuploaded2(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.license = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "license");
    },
    imageuploaded3(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.shop_bg = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "shop_bg");
    },
    imageuploaded4(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgUrl = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgUrl");
    },
    imageuploaded5(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgNegative = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgNegative");
    },

    imageuploaded6(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgPositive = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgPositive");
    },
    imageuploaded7(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgNegative2 = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgNegative2");
    },
    imageuploaded8(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgPositive2 = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgPositive2");
    },
    imageuploaded9(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.imgUrl2 = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "imgUrl2");
    },
    imageuploaded10(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.licenseUrl = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "licenseUrl");
    },
    imageuploaded11(res) {
      if (res.status !== 200) {
        if (res.msg == "Upload file does not exist") {
          return this.$dialog.error("上传图片超出10M");
        } else {
          return this.$dialog.error(res.msg || "上传图片失败");
        }
      }

      this.grantAuthUrl = res.data.url;
      this.open = true;
      this.MercInfoimg(res.data.url, "grantAuthUrl");
    },
    MercInfoimg(url, type) {
      this.$dialog.loading.open("正在上传图片");
      let that = this;
      MercInfoimg({
        url
      })
        .then(res => {
          that[type] = url;
          that[type + "_img"] = res.msg;
          that.open = false;
          that.$dialog.toast({ mes: "上传成功" });
          this.$dialog.loading.close();
        })
        .catch(res => {
          that.open = false;
          that.$dialog.toast({ mes: res.msg });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.storeApply {
  padding-bottom: 0.1rem;

  .list {
    background-color: #fff;

    .item2 {
      padding: 0 0.22rem;
      height: 0.9rem;
      background-color: #fff;
      font-size: 0.28rem;
      border-bottom: 0.01rem solid #eee;

      .left {
        width: 1.95rem;
        // color: #333;
      }

      .right {
        width: 6rem;

        .iconfont {
          color: #0e98fd;
          font-size: 0.5rem;
        }

        .icon-jinru {
          color: #666;
          font-size: 0.36rem;
        }
      }
    }

    .item {
      min-height: 0.99rem;
      border-bottom: 0.01rem solid #dcdcdc;
      padding: 0 0.23rem;

      .left {
        width: 2rem;
        font-size: 0.3rem;
        line-height: 0.99rem;
      }

      input,
      picker {
        font-size: 0.3rem;
        padding: 0 0.1rem;
        height: 1rem;
        width: 100%;
      }

      textarea {
        margin-top: -0.12rem;
        width: 100%;
        height: 1.5rem;
        padding-bottom: 0.3rem;
      }

      .address {
        width: 5.46rem;

        .a {
          width: 5rem;
          font-size: 0.3rem;
        }

        .iconfont {
          font-size: 0.34rem;
        }
      }
    }

    .logo {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;

        .a {
          font-weight: 500;
          color: #999;
        }
      }

      .pic {
        // margin-left: 0.12rem;
        width: 1.8rem;
        height: 1.8rem;
      }
    }

    .license {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;
      }

      .pic {
        margin-left: 0.12rem;
        width: 3rem;
        height: 2.06rem;
      }

      .tips {
        width: 3rem;
        color: #999;
        font-size: 0.26rem;
        margin-top: 0.24rem;
        text-align: center;
      }
    }

    .card {
      padding: 0 0.8rem 0.6rem 0.4rem;

      .title {
        line-height: 1rem;
        font-size: 0.26rem;
      }

      .img_list {
        .item_1 {
          width: 3rem;

          .pic {
            width: 3rem;
            height: 2.06rem;
            margin-bottom: 0.24rem;
          }

          .tips {
            color: #999;
            font-size: 0.26rem;
            text-align: center;
          }
        }
      }
    }
  }

  .submit {
    width: 6.9rem;
    line-height: 0.9rem;
    text-align: center;
    background-color: #0e98fd;
    color: #fff;
    border-radius: 0.45rem;
    margin: 0.6rem 0.3rem 0.3rem;
  }
}

.addressWrapper {
  .btns {
    width: 100%;
    height: 0.86rem;
    position: fixed;
    bottom: 6rem;
    left: 0;
    z-index: 556;

    background-color: #fff;
    text-align: center;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .cancel {
      color: #666;
    }

    .sure {
      color: #007aff;
    }
  }

  .pickerView {
    width: 100%;
    height: 6rem;
    position: fixed !important;
    bottom: 0;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
  }
}

.detail {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  margin-left: 0.24rem;
  color: #333;
}

.examine {
  padding: 0 0.3rem;
  text-align: right;
  color: #0e98fd;
  margin-bottom: 1rem;
}

.top {
  height: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #ccc;

  .top_type {
    width: 20%;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
  }

  .om {
    color: #0e98fd;
    font-weight: bold;
    border-bottom: 2px solid #0e98fd;
  }
}

.shanchuB {
  background-color: #939394;
  height: 0.8rem;
  color: #fff;
  // line-height: 80rem;
  width: 5.8rem;
  padding: 0 0.3rem;
  display: flex;
  align-items: center;
  position: relative;

  .shanchuB2 {
    position: absolute;
    right: -1.5rem;
    top: 0.1rem;
    height: 0.6rem;
    width: 1.4rem;
    background-color: #0e98fd;
    border-radius: 0.3rem;
    line-height: 0.6rem;
    text-align: center;
    color: #fff;
  }
}

.jinggao {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem 0.3rem;
  min-height: 0.8rem;
}

.branch_list {
  position: absolute;
  top: 1rem;
  left: 0;
  width: 7.5rem;
  max-height: 4.4rem;
  overflow-y: auto;
  background-color: #f5f5f5;
  z-index: 1000;

  .contact_li {
    height: 0.8rem;
    line-height: 0.76rem;
    text-align: center;
    font-size: 0.28rem;
    color: #333;
    border-bottom: 1px solid #ccc;
  }
}

.report {
  position: fixed;
  top: 4rem;
  left: 0.6rem;
  width: 6.3rem;
  max-height: 6rem;
  background-color: #fff;
  z-index: 1000;
  border-radius: 20rem;
  overflow-y: auto;
  padding: 0.3rem;

  .report_top {
    position: relative;
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    margin-bottom: 0.4rem;

    .icon-baseline-close-px {
      position: absolute;
      right: 0rem;
      top: 0rem;
      font-size: 0.4rem;
      font-weight: normal;
    }
  }

  .subMercList {
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.attention {
  display: inline-block;
  height: 0.6rem;
  width: 1.2rem;
  line-height: 0.6rem;
  text-align: center;
  border-radius: 0.3rem;
  background-color: #0e98fd;
  font-size: 0.26rem;
  color: #fff;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

img {
  display: block;
  width: 100%;
  height: auto;
}

.flex.flex_between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.flex.flex_around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}
.flex.ali_center {
  align-items: center;
  -webkit-align-items: center;
}
.flex.flex_center {
  justify-content: center;
  -webkit-justify-content: center;
}
.flex_col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
}
.DatetimePicker {
  height: 6rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;
}
.scbbc {
  position: absolute;
  right: 50px;
  top: 80px;
  padding: 6px 12px;
  background-color: #0e98fd;
  color: #fff;
  border-radius: 15px;
}
</style>
